export default __webpack_public_path__ + "static/14-0be297a4bc6e22114e08bc59c162f8e1.jpg";